import React, { useRef, useEffect } from "react";
import scrollReveal from "scrollreveal";


const ScrollReveal=({ children }) => {
  const sectionRef = useRef(null);
  useEffect(() => {
    if (sectionRef.current)
      scrollReveal().reveal(sectionRef.current, {
        reset: false,
        delay: 500,
        origin: 'bottom' ,
         distance :  "20px"
      });
  }, []);

  return (
    <section
      ref={sectionRef}
      className="container scroll-section"
      data-testid="section"
    >
      {children}
    </section>
  );
};

export default ScrollReveal;
